module.exports = __webpack_public_path__ + "static/img/loginrnd3.eb9e7c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/loginrnd3.png
// module id = 353
// module chunks = 0